import { useState, useEffect } from 'react';
import { TreePicker } from 'rsuite';

// Helper function to check if a value exists in the tree
const findValueInTree = (tree, value) => {
    for (const node of tree) {
        if (node.value === value) return true;
        if (node.children && findValueInTree(node.children, value)) return true;
    }
    return false;
};

const CategoryTreePicker = ({ id, onChange, categoryMap = [], defaultValue = null }) => {
    const [treeData, setTreeData] = useState([]);
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        // Build the tree structure based on parent-child relationship
        const buildTree = (parentId = null) => {
            return categoryMap
                .filter((cat) => cat.term_parent === parentId)
                .map((cat) => {
                    const hasChildren = categoryMap.some((c) => c.term_parent === cat.term_id);
                    return {
                        label: cat.term_name,
                        value: String(cat.term_id),
                        children: hasChildren ? buildTree(cat.term_id) : undefined,
                        isLeaf: !hasChildren,
                    };
                });
        };

        const tree = buildTree();
        setTreeData(tree);

        // Set default value if it exists in the tree
        if (defaultValue && findValueInTree(tree, String(defaultValue))) {
            setValue(defaultValue);
        } else {
            setValue(null);
        }
    }, [categoryMap, defaultValue]);

    // Function to fetch children for a given node
    const getChildren = async (node) => {
        const children = categoryMap
            .filter((cat) => cat.term_parent === parseInt(node.value))
            .map((cat) => ({
                label: cat.term_name,
                value: String(cat.term_id),
                children: categoryMap.some((c) => c.term_parent === cat.term_id) ? [] : undefined,
            }));

        return children;
    };

    // Handle selection changes
    const handleSelect = (val) => {
        setValue(val);
        onChange(id || 'term_parent', val);
    };

    return (
        <div className="mb-2">
            <label htmlFor="term_parent" className="form-label small mb-1">
                Parent Category <span className="text-danger">*</span>
            </label>
            <TreePicker
                data={treeData}
                value={findValueInTree(treeData, String(value)) ? String(value) : null}
                onChange={handleSelect}
                getChildren={getChildren}
                placeholder="Select Parent Category"
                style={{ width: 300 }}
                block
                searchable
            />
        </div>
    );
};

export default CategoryTreePicker;
